import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./salary.css";

export default function GenerateTeacherSalary() {

  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const schoolId = school?.school?.id;

  // Default current month
  const today = new Date();
  const currentMonth = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}`;

  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(today.getFullYear());
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);


  /* ================= LOAD SALARY LIST ================= */

  const fetchSalaryList = async () => {

    try {

      setLoading(true);

      const res = await API.get(
        "/school-admin/salary/list/",
        {
          headers: { "X-SCHOOL-ID": schoolId },
          params: { month, year }
        }
      );

      setTeachers(res.data.salaries || []);

    } catch (err) {

      console.error(err);
      alert("Failed to load teacher salary data");

    } finally {

      setLoading(false);

    }

  };


  /* ================= MARK PAID ================= */

  const markPaid = async (salaryId) => {

    if (!window.confirm("Mark this salary as paid?")) return;

    try {

      await API.post(
        `/school-admin/salary/mark-paid/${salaryId}/`,
        {},
        { headers: { "X-SCHOOL-ID": schoolId } }
      );

      fetchSalaryList();

    } catch (err) {

      console.error(err);
      alert("Error marking salary as paid");

    }

  };


  /* ================= UNDO PAYMENT ================= */

  const undoPaid = async (salaryId) => {

    if (!window.confirm("Revert this salary to unpaid?")) return;

    try {

      await API.post(
        `/school-admin/salary/undo-paid/${salaryId}/`,
        {},
        { headers: { "X-SCHOOL-ID": schoolId } }
      );

      fetchSalaryList();

    } catch (err) {

      console.error(err);
      alert("Failed to revert salary");

    }

  };


  /* ================= LOAD WHEN MONTH CHANGES ================= */

  useEffect(() => {

    fetchSalaryList();

  }, [month]);


  return (

    <div className="salary-container">

      {/* ================= HEADER ================= */}

      <div className="salary-header">

        <h2 className="page-title">
          Teacher Salary Management
        </h2>

        <div className="salary-filter">

          <label>Select Month</label>

          <input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          />

        </div>

      </div>


      {/* ================= TABLE ================= */}

      <table className="salary-table">

        <thead>

          <tr>
            <th>Teacher</th>
            <th>Salary</th>
            <th>Month</th>
            <th>Status</th>
            <th>Action</th>
          </tr>

        </thead>


        <tbody>

          {loading ? (

            <tr>
              <td colSpan="5" className="no-data">
                Loading salary data...
              </td>
            </tr>

          ) : teachers.length === 0 ? (

            <tr>
              <td colSpan="5" className="no-data">
                No teachers found for this month
              </td>
            </tr>

          ) : (

            teachers.map((t) => (

              <tr key={t.id}>

                <td className="teacher-name">
                  {t.teacher_name}
                </td>

                <td className="salary-amount">
                  ₹{t.salary}
                </td>

                <td>
                  {t.month} {t.year}
                </td>


                {/* STATUS */}

                <td>

                  {t.status === "paid" ? (

                    <span className="paid">
                      Paid
                    </span>

                  ) : (

                    <span className="pending">
                      Pending
                    </span>

                  )}

                </td>


                {/* ACTION */}

                <td>

                  {t.status === "pending" ? (

                    <button
                      className="btn small success"
                      onClick={() => markPaid(t.id)}
                    >
                      Mark Paid
                    </button>

                  ) : (

                    <button
                      className="btn small danger"
                      onClick={() => undoPaid(t.id)}
                    >
                      Unpaid
                    </button>

                  )}

                </td>

              </tr>

            ))

          )}

        </tbody>

      </table>

    </div>

  );

}